import call from './index'

//获取账户列表
export const sysAccountList = data => {
	return call('admin/admin/search', data, 'get')
}

//创建账户
export const sysCreateAccount = data => {
	return call('admin/admin/create', data)
}

//密码重置
export const initAccountPassword = (id, data) => {
	return call('admin/admin/' + id + '/password/init', data)
}

//批量修改用户禁用状态
export const batchUpdateStatus = data => {
	return call('admin/admin/status/batch_update', data)
}

//修改用户信息
export const updateAccountInfo = (id, data) => {
	return call('admin/admin/' + id + '/update', data)
}

//删除用户
export const batchDelete = data => {
	return call('admin/admin/batch_delete', data)
}

//修改密码
export function passwordupdate(data) {
	return call(`admin/admin/password/update`, data)
}

//系统账号导出
export function exportAdminAccounts(data) {
	return call(`admin/admin/export`, data, 'get')
}
